import { useMemo } from 'react';

import { Vault } from '@/shared/api/vault';

export const useGetVault = (allItems: Vault[], itemIndex: number) => {
    return useMemo(() => {
        const vault = allItems[itemIndex];

        return {
            address: vault.address,
            title: vault.title,
            leverage: vault.leverage,
            netApy: vault.netApy,
            totalDeposited: vault.totalDeposited,
            totalDepositThreshold: vault.totalDepositThreshold,
            noWalletInfo: vault.noWalletInfo,
            curator: vault.curator,
            poolUtilization: vault.poolUtilization,
            suspended: vault.suspended,
            errorContract: vault.errorContract,
        };
    }, [allItems, itemIndex]);
};
